/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_Field_SubjectInputs */

const tr_contact_form_field_subject = /** @type {(inputs: Contact_Form_Field_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konu *`)
};

const en_contact_form_field_subject = /** @type {(inputs: Contact_Form_Field_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subject *`)
};

const de_contact_form_field_subject = /** @type {(inputs: Contact_Form_Field_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betreff *`)
};

const ru_contact_form_field_subject = /** @type {(inputs: Contact_Form_Field_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тема *`)
};

/**
* | output |
* | --- |
* | "Subject *" |
*
* @param {Contact_Form_Field_SubjectInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const contact_form_field_subject = /** @type {((inputs?: Contact_Form_Field_SubjectInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_Field_SubjectInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contact_form_field_subject(inputs)
	if (locale === "de") return de_contact_form_field_subject(inputs)
	if (locale === "ru") return ru_contact_form_field_subject(inputs)
	return tr_contact_form_field_subject(inputs)
});